import { render, staticRenderFns } from "./UpgradeDialog.vue?vue&type=template&id=79e61505&scoped=true&"
import script from "./UpgradeDialog.vue?vue&type=script&lang=js&"
export * from "./UpgradeDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeDialog.vue?vue&type=style&index=0&id=79e61505&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e61505",
  null
  
)

export default component.exports